var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlexible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.362,
    y1: -0.419,
    x2: 2.643,
    y2: 1.191,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#9a00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1718ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.385,
    y1: -0.484,
    x2: 1.746,
    y2: 1.885,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.563,
    y1: -0.683,
    x2: 1.567,
    y2: 1.686,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3.948,
    y1: -0.93,
    x2: 1.056,
    y2: 0.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1.724,
    y1: -1.973,
    x2: 0.407,
    y2: 0.396,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.545,
    y1: -1.774,
    x2: 0.585,
    y2: 0.595,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(-1534 -4633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(1533.945 4633.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142_00000040537136310087749480000014645689567069207453_",
    width: 12.9,
    height: 44.6,
    transform: "translate(47.2 11.3)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143_00000114075886970262840190000012819760769082799004_",
    d: "M41.5,34l-9.1-9.1L53.6,3.7l9.1,9.1Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_144_00000056409112361164681740000013085517773412540069_",
    d: "M65.7,34,44.5,12.8l9.1-9.1L74.8,24.9Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142_00000041275280387561708440000008855694111093042076_",
    width: 12.9,
    height: 44.6,
    transform: "translate(47.2 52.5)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143_00000143581103346022932640000003116065171618968706_",
    d: "M65.7,74.4l9.1,9.1L53.6,104.7l-9.1-9.1Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_144_00000113333558562704631550000009603234125769630342_",
    d: "M41.5,74.4,62.7,95.6l-9.1,9.1L32.4,83.5Z",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142_00000010279351646506751740000003996871757482106786_",
    width: 12.9,
    height: 44.6,
    transform: "translate(47.2 52.5)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143_00000071531668104031882280000018241498192224410771_",
    d: "M65.7,74.4l9.1,9.1L53.6,104.7l-9.1-9.1Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_144_00000150090538601855772390000014711213614076502947_",
    d: "M41.5,74.4,62.7,95.6l-9.1,9.1L32.4,83.5Z",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142_00000177486812871357287190000010024279617074708645_",
    width: 44.6,
    height: 12.9,
    transform: "translate(51.9 47.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143_00000122684313591652218880000003714540636719861912_",
    width: 12.9,
    height: 30,
    transform: "translate(73.762 42.052) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144_00000031175607963349504750000014409608178072496316_",
    width: 30,
    height: 12.9,
    transform: "translate(73.831 66.246) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142_00000046337598560007742380000001945890296165954945_",
    width: 44.6,
    height: 12.9,
    transform: "translate(10.7 47.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143_00000070082344654710288440000011114178850112978826_",
    width: 12.9,
    height: 30,
    transform: "translate(3.055 54.141) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144_00000070798989459175288040000011125450036012779649_",
    width: 30,
    height: 12.9,
    transform: "translate(3.058 54.201) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142_00000168795013714819307830000007807529969945190032_",
    width: 44.6,
    height: 12.9,
    transform: "translate(10.7 47.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143_00000113326044825692951300000012660923243682027957_",
    width: 12.9,
    height: 30,
    transform: "translate(3.055 54.141) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144_00000172408975611936599540000016665327254706012856_",
    width: 30,
    height: 12.9,
    transform: "translate(3.058 54.201) rotate(-45)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 108,
    height: 108,
    transform: "translate(1534 4633)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexible);
export default __webpack_public_path__ + "static/media/flexible.234000dd1a55a93cfe3f464693a42a59.svg";
export { ForwardRef as ReactComponent };